'use strict';

// http://gitlab.alibaba-inc.com/omelette/egg-omelette-visitor/blob/master/constants/browser_type.js

module.exports = {
  baseBlackList: [{
    browserName: /UC_BROWSER/,
    os: /IOS/,
    versionRange: ['~', '10.7.0']
  }, {
    browserName: /UC_BROWSER/,
    os: /Android/,
    versionRange: ['~', '11.2.0']
  }, {
    browserName: /UC_MINI/,
    os: /Android/
  }, {
    browserName: /FACEBOOK/,
    os: /Android/
  }]
};